// extracted by mini-css-extract-plugin
export var buttons = "_9i-0";
export var buttonsActive = "_9i-h";
export var cancelConfirm = "_9i-1";
export var closeButton = "_9i-2";
export var column = "_9i-3";
export var container = "_9i-4";
export var detailHeader = "_9i-6";
export var detailTitle = "_9i-7";
export var detailsContent = "_9i-5";
export var header = "_9i-8";
export var headerWithClose = "_9i-9";
export var icon = "_9i-a";
export var infoIcon = "_9i-c";
export var informationContainer = "_9i-b";
export var sideDrawer = "_9i-d";
export var sideDrawerOpen = "_9i-e";
export var stickyFooter = "_9i-f";
export var typeOption = "_9i-g";